var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-toggle-buttons",class:{ 'is-selected': _vm.item.selected }},[_c('BaseIcon',{staticClass:"base-toggle-buttons__icon",attrs:{"name":_vm.item.icon}}),_vm._t("default",function(){return [_vm._v("Text")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }